import {
  collapsibleSlotRecipe
} from "./chunk-IQAHRUOY.mjs";
import {
  createStyleContext
} from "./chunk-7AJJGGQG.mjs";

// src/components/collapsible/styled-components.ts
import * as Collapsible from "@radix-ui/react-collapsible";
var { withContext, withProvider } = createStyleContext(collapsibleSlotRecipe);
var Root2 = withProvider(Collapsible.Root, "root");
var Trigger2 = withContext(Collapsible.Trigger, "trigger");
var Content2 = withContext(Collapsible.Content, "content");
var StyledCollapsible = Object.assign(Root2, {
  Trigger: Trigger2,
  Content: Content2
});

export {
  StyledCollapsible
};
